/**
 * WordPress dependencies
 */
const { PanelBody, Placeholder, SelectControl, ServerSideRender, TextControl, ToggleControl } = wp.components;
const { InspectorControls } = wp.editor;
const { Component } = wp.element;
const { __ } = wp.i18n;

/**
 * Internal dependencies
 */
import './block.scss';
import icon from './icon'

class Edit extends Component {

	constructor() {

		super( ...arguments );

		this.setFormId = this.setFormId.bind( this );

		let form = this.getForm( this.props.attributes.formId );
		if ( form && form.hasConditionalLogic ) {
			this.props.setAttributes( { formPreview: false } );
		}

	}

	componentWillUnmount() {

		this.unmounting = true;

	}

	setFormId( formId ) {

		let form = this.getForm( formId );

		this.props.setAttributes( { formId } );

		if ( form && form.hasConditionalLogic ) {
			this.props.setAttributes( { formPreview: false } );
		}

	}

	getForm( formId ) {

		return gform_block_form.forms.find( ( form ) => form.id == formId );

	}

	getFormOptions() {

		let options = [
			{
				label: __( 'Select a Form', 'gravityforms' ),
				value: '',
			}
		];

		for ( let i = 0; i < gform_block_form.forms.length; i++ ) {
			options.push( {
				label: gform_block_form.forms[ i ].title,
				value: gform_block_form.forms[ i ].id,
			} );
		}

		return options;

	}

	render() {

		let { formId, title, description, ajax, tabindex, formPreview } = this.props.attributes;

		const { setAttributes, isSelected } = this.props;

		const toggleTitle = () => setAttributes( { title: ! title } );
		const toggleDescription = () => setAttributes( { description: ! description } );
		const toggleAjax = () => setAttributes( { ajax: ! ajax } );
		const toggleFormPreview = () => setAttributes( { formPreview: ! formPreview } );

		const updateTabindex = ( tabindex ) => setAttributes( { tabindex } );

		const setFormIdFromPlaceholder = ( e ) => this.setFormId( e.target.value );

		const controls = [
			isSelected && (
				<InspectorControls key="inspector">
					<PanelBody
						title={ __( 'Form Settings', 'gravityforms' ) }
					>
						<SelectControl
							label={ __( 'Form', 'gravityforms' ) }
							value={ formId }
							options={ this.getFormOptions() }
							onChange={ this.setFormId }
						/>
						{
							formId && <ToggleControl
								label={ __( 'Form Title', 'gravityforms' ) }
								checked={ title }
								onChange={ toggleTitle }
							/>
						}
						{
							formId && <ToggleControl
								label={ __( 'Form Description', 'gravityforms' ) }
								checked={ description }
								onChange={ toggleDescription }
							/>
						}
					</PanelBody>
					{
						formId && <PanelBody
							title={ __( 'Advanced', 'gravityforms' ) }
							initialOpen={ false }
							className="gform-block__panel"
						>
							{
								formId && ! this.getForm( formId ).hasConditionalLogic &&
								<ToggleControl
									label={ __( 'Preview', 'gravityforms' ) }
									checked={ formPreview }
									onChange={ toggleFormPreview }
								/>
							}
							<ToggleControl
								label={ __( 'AJAX', 'gravityforms' ) }
								checked={ ajax }
								onChange={ toggleAjax }
							/>
							<TextControl
								label={ __( 'Tabindex', 'gravityforms' ) }
								value={ tabindex }
								onChange={ updateTabindex }
								placeholder="-1"
							/>
						</PanelBody>
					}
				</InspectorControls>
			),
		];

		if ( ! formId || ! formPreview ) {

			return [
				controls,
				<Placeholder key="placeholder" className="wp-block-embed gform-block__placeholder">
					<div className="gform-block__placeholder-brand">
						<div className={ 'gform-icon' }>{ icon }</div>
						<p><strong>Gravity Forms</strong></p>
					</div>
					<form>
						<select value={ formId } onChange={ setFormIdFromPlaceholder }>
							{ this.getFormOptions().map( form =>
								<option key={ form.value } value={ form.value }>{ form.label }</option>,
							) }
						</select>
					</form>
				</Placeholder>,
			];

		}

		return [
			controls,
			<ServerSideRender
				key="form_preview"
				block="gravityforms/form"
				attributes={ this.props.attributes }
			/>,
		];

	}

}

export default Edit